import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/lastfm': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M225.8 367.1c0 0-31.7 31.1-97.9 31.1-82.2 0-127.9-48.1-127.9-137.2 0-92.7 45.7-147.2 131.8-147.2 117.7 0 129.3 66.2 161.3 163 14 42.8 38.7 73.9 97.9 73.9 39.9 0 61-8.8 61-30.5 0-31.9-34.9-35.1-79.8-45.7-48.6-11.7-68-36.9-68-76.8 0-64 51.6-83.9 104.4-83.9 59.8 0 96.2 21.7 100.9 74.5l-58.6 7c-2.3-25.2-17.5-35.8-45.7-35.8-25.8 0-41.6 11.8-41.6 31.7 0 17.6 7.6 28.1 33.4 34 52.3 11.5 115 19.2 115 92.1 0 58.6-49.3 80.9-122 80.9-101.4 0-136.6-45.7-155.4-102.6-26.1-81.6-34.4-134.9-100.9-134.9-35.7 0-72.1 25.8-72.1 97.9 0 56.3 28.7 91.5 69.2 91.5 45.7 0 76.2-34 76.2-34z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/lastfm.js
// module id = 914
// module chunks = 0